export function bytesToKilobytes(bytes) {
    return (bytes / 1000).toFixed(2)
}

export function bytesToMegabytes(bytes) {
    return (bytes / (1000 * 1000)).toFixed(2)
}

export function getHumanReadableBytes(file_size) {
    if (file_size < 1000) {
        return file_size + " Bytes"
    } else if (file_size < 1000 * 1000) {
        return bytesToKilobytes(file_size) + " kBytes"
    } else if (file_size < 1000 * 1000 * 1000) {
        return bytesToMegabytes(file_size) + " MBytes"
    }
}